import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrDocumentError = createSelector([selectQbrState], (state) => state.error)
